import { Badge } from 'react-bootstrap'

export type BadgeListonClick = (value: string) => void
export type BadgeItem = {
    _id: string
    value: string
    slug: string
}

export type BadgeProps = {
    list: BadgeItem[]
    onClick: BadgeListonClick
    activeItem?: string
    customClass?: string
    hideAll?: boolean
}

export default function BadgeList({ list, onClick, customClass, activeItem, hideAll }: BadgeProps) {
    const componentClass = `BadgeList ${customClass ?? ''}`

    const handleCategoryClick = (id: string) => {
        onClick(id)
    }

    return (
        <div className={componentClass}>
            {!hideAll ?? (
                <Badge
                    className={`cursor-pointer ${!activeItem ? 'active' : ''}`}
                    bg="secondary"
                    onClick={() => handleCategoryClick('')}
                >
                    All
                </Badge>
            )}
            {list &&
                list.map((p: BadgeItem) => (
                    <Badge
                        className={`cursor-pointer ${activeItem === p.slug ? 'active' : ''}`}
                        key={p._id}
                        bg="secondary"
                        onClick={() => handleCategoryClick(p._id)}
                    >
                        {p.value}
                    </Badge>
                ))}
        </div>
    )
}
